export const ACCESS_DENIED_REASON_HEADER = 'X-Anchorage-Access-Denied-Reason';
export const ACCESS_DENIED_REASON_IP_BLOCKED = 'ip_allowlist';

/**
 * An allowlist denial and an expired session are both 401, so only this header
 * tells them apart. Values mirror Go's `accesspolicy` constants; change one
 * side alone and detection silently stops.
 */
export const isIPBlockedResponse = (response?: Response | null): boolean =>
  // Chained: responses come off error objects that may carry no Headers, and
  // anything unreadable must fall through to the login redirect.
  response?.headers?.get?.(ACCESS_DENIED_REASON_HEADER) ===
  ACCESS_DENIED_REASON_IP_BLOCKED;
